import React, { useEffect } from "react";
import { Card, Col, Row, Breadcrumb } from "antd";
import { RootState, useAppDispatch } from "../../../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import useMultiNotification from "../../../hooks/useNotification";
import { Link, useParams } from "react-router-dom";
import LeftCol from "../../wrappers/NewEntryFormLeftColWrapper";
import RightCol from "../../wrappers/NewEntryFormRightColWrapper";
import UserProfileTab from "./UserProfileTab";
import { getUserProfileApi } from "../../../redux-toolkit/slices/dashboardSlice";
const SingleUserComponent = () => {
  const generalState = useSelector((state: RootState) => state.general);
  const { reloadApiCount } = useSelector((state: RootState) => state.dashboard);
  const { isShowTableInDesktop } = generalState;
  const { contextHolder, openNotification } = useMultiNotification();
  const { userId, fullName } = useParams();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getUserProfileApi(`${userId}`));
  }, []);
  useEffect(() => {
    if (reloadApiCount > 0) {
      dispatch(getUserProfileApi(`${userId}`));
    }
  }, [reloadApiCount]);
  return (
    <>
      {contextHolder}
      <Card>
        <Row className="mb-10">
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={`/view-users`}>Users</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{fullName}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="mt-10">
          <LeftCol>
            <p></p>
            {/* <UserProfileTabs /> */}
          </LeftCol>
          <RightCol>
            <div className="dashboard-search-container"></div>
          </RightCol>
        </Row>
        <Row style={{ width: "100%", marginTop: "20px" }}>
          <UserProfileTab />
        </Row>
      </Card>
    </>
  );
};
export default SingleUserComponent;
